module.exports = __webpack_public_path__ + "img/icone-roubo.03daa44a.svg";